import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import DropDownSelector from "../micro_components/DropDownSelector";
import Button from "@material-ui/core/Button";
import CreatorService from "../../services/CreatorService";
import Dropzone from "../micro_components/DropZone";
import ConfirmationModal from "../micro_components/ConfirmationModal";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const nameStyle = {
  fontWeight: "500",
};

const domainStyle = {};

const CreatorCard = ({ creator, collapseListener, collapseTrigger, index, domains, history, setCreators, domain }) => {
  const { id, name, lastName } = creator;
  const [expanded, setExpanded] = useState(false);
  const [hover, setHover] = useState(false);
  const [localCreator, setLocalCreator] = useState(creator);

  const [galleryImage, setGalleryImage] = useState(null);
  const [mainImage, setMainImage] = useState(null);

  const [galleryImageURL, setGalleryImageURL] = useState(null);
  const [mainImageURL, setMainImageURL] = useState(null);

  const [description, setDescription] = useState("");

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(true);

  useEffect(() => {
    CreatorService.getCreatorDescription(id)
      .then((response) => setDescription(response.data))
      .catch((e) => console.log("error getting creator description: ", e));
  }, []);

  useEffect(() => {
    if (creator) {
      if (creator.mainImageURL) {
        setMainImageURL(`https://da9nh4xe5cncw.cloudfront.net/${id}/${creator.mainImageURL}`);
      }
      if (creator.galleryImageURL) {
        setGalleryImageURL(`https://da9nh4xe5cncw.cloudfront.net/${id}/${creator.galleryImageURL}`);
      }
    }
  }, [creator]);

  useEffect(() => {
    // console.log("domain: ", domain);
  }, [domain]);
  useEffect(() => {
    if (collapseListener !== index) {
      setExpanded(false);
    }
  }, [collapseListener, index]);

  useEffect(() => {
    if (id === 4) {
      // console.log(mainImageURL);
    }
  }, [mainImageURL, id]);

  const expandCard = () => {
    setExpanded(!expanded);
    collapseTrigger(index);
  };

  const containerStyle = {
    margin: "20px 5px",
    boxShadow: "0 0 0.25em 0.12em rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // flexGrow: "0",
    flexGrow: expanded ? "3" : "0",
    // flexShrink: "3",
    // flexBasis: expanded ? "50%" : "30%",
    width: expanded ? "50%" : "32%",
    // width: expanded ? "auto" : "200px",
    transition: "all 0.6s ease-out",
  };

  const contentStyle = {
    overflow: expanded ? "scroll" : "hidden",
    height: expanded ? "auto" : "0",
    transition: "all 0.5s ease",
    opacity: expanded ? "1" : "0",
    display: "flex",
    flexDirection: "column",
    width: "90%",
    paddingTop: expanded ? "20px" : "0",
  };

  const labelStyle = {
    width: "100%",
    height: "100%",
    background: hover ? "#dedede" : "white",
    transition: "all 1s ease",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const buttonContainerStyle = {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginBottom: "15px",
  };

  const contentItemStyle = {
    margin: "10px 0",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("name: " + name, " value: " + value);
    // console.log(event.target);
    setLocalCreator({ ...localCreator, [name]: value });
  };

  // useEffect(() => {
  //   console.log(localCreator)
  // }, [localCreator]);

  const handleDomainSelect = (e) => {
    console.log(domains);
    console.log(e);
    setLocalCreator({ ...localCreator, domain_id: parseInt(e) });
  };

  const saveChanges = () => {
    setConfirmationLoading(true);
    setConfirmationOpen(true);
    console.log("saving changes");
    let formatted = {
      name: localCreator.name,
      lastName: localCreator.lastName,
      domain_id: localCreator.domain_id,
      spotify_link: localCreator.spotify_link,
      youtube_link: localCreator.youtube_link,
      artist_website_link: localCreator.artist_website_link,
      facebook_link: localCreator.facebook_link,
      instagram_link: localCreator.instagram_link,
      introVideoLink: localCreator.introVideoLink,
      featuredArtist: localCreator.featuredArtist,
    };
    console.log("formatted: ", formatted);
    CreatorService.update(id, formatted)
      .then((response) => {
        console.log("creator updated");
        setConfirmationLoading(false);
      })
      .catch((e) => console.log("error updating creator: " + e));

    if (mainImage) {
      // console.log("setting main image: " + JSON.stringify(mainImage));
      CreatorService.uploadMainImage(id, mainImage)
        .then(() => {
          console.log("uploaded main image");
        })
        .catch((e) => {
          console.log("error uploading main image: " + e);
        });
    }
    if (galleryImage) {
      console.log("gallery image: " + JSON.stringify(galleryImage));
      CreatorService.uploadGalleryImage(id, galleryImage)
        .then(() => {
          console.log("uploaded gallery image");
        })
        .catch((e) => {
          console.log("error uploading gallery image: " + e);
        });
    }

    if (description && description.length > 0) {
      uploadDescription();
    }
  };

  const uploadDescription = () => {
    const data = new FormData();

    // const element = document.createElement("a");
    const file = new Blob([description], { type: "text/plain" });

    data.append("file", file);

    CreatorService.uploadCreatorDescription(id, data)
      .then((response) => console.log(response.data))
      .catch((e) => console.log("error uploading creator description: ", e));
  };

  const openDeleteModal = () => {
    console.log("open delete modal");
    if (window.confirm("Are you sure you want to delete " + name + "?")) {
      CreatorService.remove(id)
        .then((response) => {
          console.log(response.data);
          setCreators(response.data);
          window.location.reload(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  // HANDLE WHEN COVER IMAGE IS PLACED
  const handleGalleryImageSet = (data) => {
    setGalleryImage(data);
    console.log("SETTING GALLERY IMAGE");
  };

  const handleMainImageSet = (data) => {
    setMainImage(data);
    console.log("SETTING MAIN IMAGE");
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleConfirmationClose = () => {
    setConfirmationOpen(false);
  };

  const handleFeaturedCheck = (e) => {
    setLocalCreator({ ...localCreator, featuredArtist: e.target.checked });
  };

  return (
    <>
      {domain && creator && localCreator && localCreator.domain_id && (
        <div style={containerStyle}>
          <div
            style={labelStyle}
            onClick={expandCard}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <div style={nameStyle}>{name}</div>
            <div style={domainStyle}>{domain.name}</div>
          </div>
          <div style={contentStyle}>
            {expanded && (
              <>
                <FormControlLabel
                  control={<Checkbox checked={localCreator.featuredArtist} onChange={handleFeaturedCheck} />}
                  label="Featured Artist"
                />
                <Dropzone
                  originalFile={galleryImageURL}
                  label={"Gallery Picture"}
                  setFileData={handleGalleryImageSet}
                  width={200}
                  height={200}
                />
                {/* <img
                  src={"https://da9nh4xe5cncw.cloudfront.net/1/mainImage1"}
                /> */}
                <div style={{ margin: "25px 0" }}>
                  {/* <img src={setMainImageURL} /> */}
                  <Dropzone
                    originalFile={mainImageURL}
                    label={"Main Picture"}
                    setFileData={handleMainImageSet}
                    width={200}
                    height={200}
                  />
                </div>

                <TextField
                  style={contentItemStyle}
                  defaultValue={name}
                  label="Name"
                  variant="filled"
                  name="name"
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  style={contentItemStyle}
                  defaultValue={lastName}
                  label="Last Name"
                  variant="filled"
                  name="lastName"
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  style={contentItemStyle}
                  value={localCreator.spotify_link}
                  defaultValue={localCreator.spotify_link}
                  label="Spotify"
                  variant="filled"
                  name="spotify_link"
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  style={contentItemStyle}
                  defaultValue={localCreator.youtube_link}
                  label="Youtube"
                  variant="filled"
                  name="youtube_link"
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  style={contentItemStyle}
                  defaultValue={localCreator.instagram_link}
                  label="Instagram"
                  variant="filled"
                  name="instagram_link"
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  style={contentItemStyle}
                  defaultValue={localCreator.facebook_link}
                  label="Facebook"
                  variant="filled"
                  name="facebook_link"
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  style={contentItemStyle}
                  defaultValue={localCreator.artist_website_link}
                  label="Artist Website"
                  variant="filled"
                  name="artist_website_link"
                  onChange={handleChange}
                  fullWidth
                />

                <TextField
                  style={contentItemStyle}
                  defaultValue={localCreator.introVideoLink}
                  label="Artist Intro Video Link"
                  variant="filled"
                  name="introVideoLink"
                  onChange={handleChange}
                  fullWidth
                />

                <DropDownSelector
                  style={contentItemStyle}
                  data={domains}
                  placeholder={"Domain"}
                  value={localCreator.domain_id}
                  onChange={handleDomainSelect}
                />
                <div style={{ margin: "15px 0 15px 0" }}>
                  <TextField
                    placeholder="Description"
                    multiline
                    variant="outlined"
                    minRows={8}
                    maxRows={Infinity}
                    value={description}
                    onChange={handleDescriptionChange}
                    fullWidth
                  />
                </div>
                <div style={buttonContainerStyle}>
                  <Button size="small" color="secondary" style={{ marginLeft: "" }} onClick={openDeleteModal}>
                    Delete Creator
                  </Button>
                  <Button size="small" color="primary" style={{ marginLeft: "5px" }} onClick={saveChanges}>
                    Save Changes
                  </Button>
                </div>
              </>
            )}
          </div>
          {confirmationOpen && (
            <ConfirmationModal
              title="Creator changes saved!"
              isOpen={confirmationOpen}
              onClose={handleConfirmationClose}
              isLoading={confirmationLoading}
            />
          )}
        </div>
      )}
    </>
  );
};

export default CreatorCard;
